import { useMutation } from '@tanstack/react-query'

import { deleteCampaignImageVariants } from '../api'

export const useDeleteImageVariantsMutation = () => {
  return useMutation({
    mutationFn: deleteCampaignImageVariants,
  })
}
